export const projectData = [
  {
    title: "Dog Breed App (PERN Stack)",
    src: "/images/dogBreedApp.png",
    alt: "Dog Breed App",
    url: "https://dogbreed-academy.netlify.app/",
    description:
      "Dog Breed App created using a PERN stack, users can vote on one of the two diplayed Dogs and can view the Leaderboard of the Top most Voted Dogs",
    tag: [
      "HTML5",
      "CSS3",
      "TypeScript",
      "React",
      "Express.js",
      "Node.js",
      "PostgreSQL",
      "Figma",
    ],
  },
  {
    title: "Yamdle (Wordle Clone)",
    src: "/images/yamdle.png",
    alt: "Yamdle App",
    url: "https://yamdle.netlify.app/",
    description:
      "Wordle Clone built completely from stratch using only my own ideas amd methods - not limited to one word a day; Users can refresh and get a new word each time.",
    tag: ["HTML5", "CSS3", "TypeScript", "React"],
  },
  {
    title: "Tv Shows App",
    src: "/images/tvShowApp.png",
    alt: "Tv Show App",
    url: "https://tv-shows-fola-az.netlify.app/",
    description:
      "Tv Show app where users can find infomation on a large list of Tv shows and their respective episodes",
    tag: ["HTML5", "CSS3", "TypeScript", "React", "Figma"],
  },
  {
    title: "Protoype Client Dashboard",
    src: "/images/dashboardApp.png",
    alt: "Dashboard",
    url: "https://cropsquad-fola.netlify.app/",
    description:
      "Prototype Client Dashboard where users can view projects and view respective client and employee Data",
    tag: ["HTML5", "CSS3", "TypeScript", "React"],
  },
  {
    title: "Pastebin App",
    src: "/images/pastebinApp.png",
    alt: "Pastebin App",
    url: "https://paste-bin-sofo.netlify.app/",
    description:
      "User can use the app to easily upload 'Paste' text content for others to retrieve; traditionally used to support platforms that didn't allow for code snippets uploads",
    tag: [
      "HTML5",
      "CSS3",
      "TypeScript",
      "React",
      "Express.js",
      "Node.js",
      "PostgreSQL",
      "Figma",
    ],
  },
];

// interface props{
//     title:string,
// src:string,
// alt:string,
// url:string,
// description:string,
// tag:string[]
//   }
